// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1j6VC","colMin":"styles_colMin__3hUpj","colCheckbox":"styles_colCheckbox__38nT-"};